export const sideOptions = [
    {value: 2, label: 'Double'},
    {value: 0, label: 'Front'},
    {value: 1, label: 'Back'},
]

